
import {
    Box,
    Typography,
} from '@mui/material'
import { Image } from 'antd'
import IntroductionBanner from '../../../assets/about-us/about-introduction-banner.jpg'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMMotorLoanIntroduction: React.FC = () => {

    const { t } = useTranslation()

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                paddingLeft: isTablet ? '40px' : '60px',
                paddingRight: isTablet ? '40px' : '60px',
                paddingTop: '60px',
                paddingBottom: '60px',
                alignItems: 'center',
                backgroundColor: '#FFFFFF',
            }}
        >

            <Box sx={{
                flex: '1',
                display: 'flex',
                flexDirection: 'column',
            }}>
                <Typography fontSize={32} fontWeight={700} color={'#141F39'}>
                    {t('t112')}
                </Typography>

                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={isTablet ? '20px' : '40px'}>
                    {t('t113')}
                </Typography>

                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={isTablet ? '20px' : '40px'}>
                    {t('t114')}
                </Typography>

                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={isTablet ? '20px' : '40px'}>
                    {t('t115')}
                </Typography>

            </Box>

            <Box sx={{paddingLeft: isTablet ? '20px' : '48px',}}>
                <Image src={IntroductionBanner} width={isTablet ? 460 : 556} height={isTablet ? 430 : 520} alt='' style={{objectFit: 'cover', borderRadius: '10px' }} preview={false}></Image>
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMMotorLoanIntroduction
